import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { fetchCurrencyQueryFn } from './queryFn/fetch-currency.query';
import { fetchProductPricingQueryFn } from './queryFn/fetch-product-pricing.query';
import { fetchCyclePricingQueryFn } from './queryFn/fetch-cycle-pricing.query';
import { fetchMoneyFormatterQueryFn } from './queryFn/fetch-money-formatter.query';
import { fetchFeaturesGridQueryFn } from './queryFn/fetch-features-grid.query';
import { fetchMonthlyDisabledFeaturesQueryFn } from './queryFn/fetch-monthly-disabled-features.query';
import { fetchOfferingDiscountQueryFn } from './queryFn/fetch-offering-discount.query';
import { fetchOfferingQueryFn } from './queryFn/fetch-offering.query';
import { fetchProductQueryFn } from './queryFn/fetch-product.query';
import { fetchProductDescriptionQueryFn } from './queryFn/fetch-product-description.query';
import { fetchTaxStatusQueryFn } from './queryFn/fetch-tax-status.query';
import { fetchUserSessionContextQueryFn } from './queryFn/fetch-user-session-context.query';
export const EclipseOfferingQueriesConfig = createQueriesConfig({
  fetchProduct: {
    queryFn: fetchProductQueryFn
  },
  fetchOffering: {
    queryFn: fetchOfferingQueryFn
  },
  fetchOfferingDiscount: {
    queryFn: fetchOfferingDiscountQueryFn
  },
  fetchTaxStatus: {
    queryFn: fetchTaxStatusQueryFn
  },
  fetchUserSessionContext: {
    queryFn: fetchUserSessionContextQueryFn
  },
  fetchCurrency: {
    queryFn: fetchCurrencyQueryFn
  },
  fetchProductPricing: {
    queryFn: fetchProductPricingQueryFn
  },
  fetchCyclePricing: {
    queryFn: fetchCyclePricingQueryFn
  },
  fetchMoneyFormatter: {
    queryFn: fetchMoneyFormatterQueryFn
  },
  fetchMonthlyDisabledFeatures: {
    queryFn: fetchMonthlyDisabledFeaturesQueryFn
  },
  fetchFeaturesGrid: {
    queryFn: fetchFeaturesGridQueryFn
  },
  fetchProductDescription: {
    queryFn: fetchProductDescriptionQueryFn
  }
});
//# sourceMappingURL=eclipse-offering.queries.js.map